module.exports = __webpack_public_path__ + "img-dashboard/register/empty-photo.bb41293c.png";